{
  "familyId": "SWW-BN-VD-KORT",
  "questions": [
    {
      "id": "SWW-BN-VD-KORT-001",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je: 'de ... auto' (verbranden → als bijvoeglijk naamwoord)?",
      "context": null,
      "options": ["verbrande", "verbranden", "verbrandde", "verbrandene"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Bijvoeglijk naamwoord van VD", "content": "Voltooid deelwoord + e = bijvoeglijk naamwoord. Bij een LANGE klank: NIET verdubbelen. 'Verbrand' heeft een lange 'a' → verbrande (niet verbrandde).", "icon": "lightbulb"}, "showWhen": "wrong"}],
      "conceptId": "adjective_from_past_participle_long",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het voltooid deelwoord van 'verbranden' is 'verbrand'. De 'a' in 'verbrand' is een lange klank. Bij een lange klank voeg je gewoon -e toe zonder de medeklinker te verdubbelen: verbrand + e = verbrande. Vergelijk: 'verbrandde' zou een korte klank suggereren, maar de 'a' is lang.",
        "solutionSteps": [
          "Bepaal het voltooid deelwoord: verbranden → verbrand",
          "Luister naar de klinker: 'verbrand' heeft een lange 'a'",
          "Lange klinker → gewoon + e (geen verdubbeling): verbrande",
          "Check: 'verbrandde' suggereert korte klank — fout"
        ],
        "distractorExplanations": {
          "0": "Correct! Lange klank → gewoon + e: verbrande (niet verbrandde).",
          "1": "Je dacht waarschijnlijk dat je het hele werkwoord als bijvoeglijk naamwoord kunt gebruiken. Maar 'verbranden' is de infinitief. Als bijvoeglijk naamwoord gebruik je het voltooid deelwoord + e: verbrande. Onthoud: VD + e = bijvoeglijk naamwoord.",
          "2": "Je dacht waarschijnlijk dat je de 'd' moet verdubbelen. Maar 'verbrandde' suggereert een korte klank. De 'a' in 'verbrand' is lang, dus geen verdubbeling nodig. Onthoud: lange klank → NIET verdubbelen.",
          "3": "Je dacht waarschijnlijk dat bijvoeglijke naamwoorden -ene krijgen. Maar 'verbrandene' is te lang. De regel is simpel: voltooid deelwoord + e = verbrande. Onthoud: alleen + e, geen extra lettergrepen."
        }
      }
    },
    {
      "id": "SWW-BN-VD-KORT-002",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "multiple_choice",
      "question": "Welke zin is juist?",
      "context": null,
      "options": ["De geverfde muur ziet er mooi uit.", "De geverfden muur ziet er mooi uit.", "De geverfdde muur ziet er mooi uit.", "De geverfte muur ziet er mooi uit."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Bijvoeglijk naamwoord van VD", "content": "Voltooid deelwoord + e = bijvoeglijk naamwoord. 'Geverfd' heeft een lange 'e' → geverfde (niet geverfdde). Verdubbel NIET bij een lange klank.", "icon": "lightbulb"}, "showWhen": "wrong"}],
      "conceptId": "adjective_from_past_participle_geverfd",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Het voltooid deelwoord van 'verven' is 'geverfd'. De 'e' in 'geverfd' is een lange klank. Bij een lange klank voeg je gewoon -e toe: geverfd + e = geverfde. Geen verdubbeling nodig.",
        "solutionSteps": [
          "Bepaal het voltooid deelwoord: verven → geverfd",
          "Luister naar de klinker: 'geverfd' heeft een lange 'e'",
          "Lange klinker → gewoon + e: geverfd + e = geverfde",
          "Check: 'geverfdde' heeft dubbele d — fout bij lange klank"
        ],
        "distractorExplanations": {
          "0": "Correct! Lange klank → gewoon + e: geverfde.",
          "1": "Je dacht waarschijnlijk dat het -en krijgt. Maar 'geverfden' lijkt op een verouderde meervoudsvorm. Bijvoeglijke naamwoorden krijgen alleen -e: geverfde. Onthoud: VD + e, niet VD + en.",
          "2": "Je dacht waarschijnlijk dat je de 'd' moet verdubbelen. Maar de 'e' in 'geverfd' is een lange klank, dus geen verdubbeling. Onthoud: lange klank → NIET verdubbelen.",
          "3": "Je dacht waarschijnlijk dat de kofschip-regel geldt. Maar het voltooid deelwoord is 'geverfd' (met d), niet 'geverft'. Als bijvoeglijk naamwoord: geverfd + e = geverfde. Onthoud: gebruik het VD als basis, niet de stam."
        }
      }
    },
    {
      "id": "SWW-BN-VD-KORT-003",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je: 'het ... kind' (verwennen → als bijvoeglijk naamwoord)?",
      "context": null,
      "options": ["verwende", "verwennde", "verwennen", "verwend"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Korte vs. lange klank", "content": "Het VD van 'verwennen' is 'verwend'. De 'e' in 'verwend' is KORT (vergelijk: 'wen'). Maar het medeklinkercluster 'nd' houdt de klank al kort — je hoeft de 'n' niet te verdubbelen. Dus: verwend + e = verwende.", "icon": "lightbulb"}, "showWhen": "wrong"}],
      "conceptId": "adjective_short_vowel_cluster",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Het voltooid deelwoord van 'verwennen' is 'verwend'. De 'e' is kort, maar het medeklinkercluster 'nd' houdt de klank al kort. Je hoeft dus niet te verdubbelen: verwend + e = verwende. Vergelijk: 'verwennde' zou een dubbele 'n' toevoegen die niet nodig is.",
        "solutionSteps": [
          "Bepaal het voltooid deelwoord: verwennen → verwend",
          "Luister naar de klinker: korte 'e'",
          "Het cluster 'nd' houdt de klank al kort → geen verdubbeling nodig",
          "verwend + e = verwende"
        ],
        "distractorExplanations": {
          "0": "Correct! Het medeklinkercluster 'nd' houdt de korte klank al kort: verwende.",
          "1": "Je dacht waarschijnlijk dat je de 'n' moet verdubbelen bij een korte klank. Maar het cluster 'nd' houdt de klank al kort — extra verdubbeling is niet nodig. Onthoud: bij een medeklinkercluster (nd, ld, nk, etc.) hoef je niet te verdubbelen.",
          "2": "Je dacht waarschijnlijk dat je de infinitief als bijvoeglijk naamwoord kunt gebruiken. Maar 'verwennen' is het hele werkwoord. Gebruik het VD + e: verwend + e = verwende. Onthoud: VD + e = bijvoeglijk naamwoord.",
          "3": "Je dacht waarschijnlijk dat het VD zonder -e al als bijvoeglijk naamwoord kan. Maar vóór een zelfstandig naamwoord krijgt het bijvoeglijk naamwoord altijd -e: 'het verwende kind', niet 'het verwend kind'. Onthoud: bijvoeglijk naamwoord vóór znw = altijd + e."
        }
      }
    },
    {
      "id": "SWW-BN-VD-KORT-004",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "multiple_choice",
      "question": "Welk bijvoeglijk naamwoord is FOUT geschreven?",
      "context": null,
      "options": ["de gestreeptte kat", "de gebroken vaas", "de gestolen fiets", "de gesloten deur"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Verdubbeling controleren", "content": "Bij een lange klank: NIET verdubbelen. 'Gestreept' heeft een lange 'ee' → gestreepte (niet gestreeptte). De andere woorden zijn sterke VD's die op -en eindigen en geen -e nodig hebben.", "icon": "lightbulb"}, "showWhen": "wrong"}],
      "conceptId": "adjective_error_detection",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Gestreeptte' is fout. Het VD van 'strepen' is 'gestreept'. De 'ee' is een lange klank, dus geen verdubbeling van de 't': gestreept + e = gestreepte. De andere woorden zijn correct: 'gebroken', 'gestolen' en 'gesloten' zijn sterke VD's die al op -en eindigen.",
        "solutionSteps": [
          "Controleer elk woord: is de verdubbeling correct?",
          "'Gestreeptte' → dubbele 't' bij lange 'ee' → FOUT",
          "Correct: gestreept + e = gestreepte (lange klank, niet verdubbelen)",
          "De andere drie zijn sterke VD's op -en: correct"
        ],
        "distractorExplanations": {
          "0": "Correct gevonden! 'Gestreeptte' is fout — de 'ee' is lang, dus geen verdubbeling: gestreepte.",
          "1": "Je dacht waarschijnlijk dat 'gebroken' fout is. Maar 'gebroken' is een sterk voltooid deelwoord dat al op -en eindigt. Het is correct als bijvoeglijk naamwoord: 'de gebroken vaas'. Onthoud: sterke VD's op -en hoeven geen extra -e.",
          "2": "Je dacht waarschijnlijk dat 'gestolen' fout is. Maar 'gestolen' is een sterk VD op -en. Het is correct: 'de gestolen fiets'. Onthoud: sterke VD's op -en zijn al bijvoeglijk naamwoorden.",
          "3": "Je dacht waarschijnlijk dat 'gesloten' fout is. Maar 'gesloten' is een sterk VD op -en. Het is correct: 'de gesloten deur'. Onthoud: sterke VD's op -en hoeven geen extra -e."
        }
      }
    },
    {
      "id": "SWW-BN-VD-KORT-005",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je: 'de ... taart' (bakken → als bijvoeglijk naamwoord)?",
      "context": null,
      "options": ["gebakken", "gebakte", "gebakkene", "gebakke"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Sterke VD's als bijvoeglijk naamwoord", "content": "Sommige werkwoorden hebben een sterk VD dat op -en eindigt: bakken → gebakken. Deze VD's zijn al bijvoeglijk naamwoord: 'de gebakken taart'. Je hoeft geen extra -e toe te voegen.", "icon": "lightbulb"}, "showWhen": "wrong"}],
      "conceptId": "adjective_strong_participle",
      "variantIndex": 5,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Bakken' is een sterk werkwoord. Het voltooid deelwoord is 'gebakken' (niet 'gebakt'). Sterke VD's die op -en eindigen zijn al bijvoeglijk naamwoord: 'de gebakken taart'. Je hoeft geen extra -e toe te voegen.",
        "solutionSteps": [
          "Bepaal het VD: bakken → gebakken (sterk werkwoord)",
          "'Gebakken' eindigt op -en → al bruikbaar als bijvoeglijk naamwoord",
          "Geen extra -e nodig: 'de gebakken taart'",
          "Vergelijk: 'de gebroken vaas', 'de gestolen fiets' (ook sterk)"
        ],
        "distractorExplanations": {
          "0": "Correct! 'Gebakken' is een sterk VD op -en en is al bijvoeglijk naamwoord.",
          "1": "Je dacht waarschijnlijk dat het VD 'gebakt' is (kofschip). Maar 'bakken' is een sterk werkwoord: gebakken (niet gebakt). Onthoud: sterk VD = stamverandering + -en (bakken → gebakken, breken → gebroken).",
          "2": "Je dacht waarschijnlijk dat je -ene moet toevoegen. Maar 'gebakkene' bestaat niet. Sterke VD's op -en zijn al bijvoeglijk naamwoord zonder extra uitgang. Onthoud: gebakken = al klaar.",
          "3": "Je dacht waarschijnlijk dat je de -n kunt weglaten. Maar 'gebakke' is geen correct woord. Het sterke VD is 'gebakken' — gebruik het volledig. Onthoud: sterke VD's op -en blijven onveranderd."
        }
      }
    },
    {
      "id": "SWW-BN-VD-KORT-006",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "matching",
      "question": "Koppel elk werkwoord aan het juiste bijvoeglijk naamwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["verbranden", "stelen", "verwennen", "strepen"],
        "rightItems": ["gestolen", "verwende", "gestreepte", "verbrande"],
        "correctMatches": { "0": 3, "1": 0, "2": 1, "3": 2 }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "VD → bijvoeglijk naamwoord", "content": "Zwak VD + e: verbranden → verbrand → verbrande. verwennen → verwend → verwende. strepen → gestreept → gestreepte. Sterk VD op -en: stelen → gestolen (al bijvoeglijk naamwoord).", "icon": "lightbulb"}, "showWhen": "wrong"}],
      "conceptId": "adjective_matching_overview",
      "variantIndex": 6,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.67,
      "feedback": {
        "explanationText": "verbranden → verbrand + e = verbrande (lange 'a', geen verdubbeling). stelen → gestolen (sterk VD op -en, al bijvoeglijk naamwoord). verwennen → verwend + e = verwende (cluster 'nd' houdt klank kort). strepen → gestreept + e = gestreepte (lange 'ee', geen verdubbeling).",
        "solutionSteps": [
          "verbranden → VD: verbrand → + e = verbrande",
          "stelen → VD: gestolen (sterk, al bijvoeglijk naamwoord)",
          "verwennen → VD: verwend → + e = verwende",
          "strepen → VD: gestreept → + e = gestreepte"
        ]
      }
    },
    {
      "id": "SWW-BN-VD-KORT-007",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "fill_in",
      "question": "Vul in: de ... (verbranden → bijvoeglijk naamwoord) muur was verbrand.",
      "correctAnswer": "verbrande",
      "data": {
        "acceptedAnswers": ["verbrande"],
        "placeholder": "bijvoeglijk naamwoord...",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Bijvoeglijk naamwoord van VD", "content": "Verbranden is een zwak werkwoord: VD = verbrand. Bijvoeglijk naamwoord = VD + e = verbrande. 'Verbrande' is het juiste bijvoeglijk naamwoord.", "icon": "lightbulb" } }
      ],
      "conceptId": "bn_vd_fill_in_verbrande",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Verbranden is een zwak werkwoord. Het voltooid deelwoord is 'verbrand'. Bijvoeglijk naamwoord = VD + e = verbrande. 'Verbrande' is het juiste bijvoeglijk naamwoord.",
        "solutionSteps": [
          "Bepaal het VD: verbranden → verbrand",
          "Bijvoeglijk naamwoord = VD + e = verbrande",
          "De verbrande muur"
        ]
      }
    },
    {
      "id": "SWW-BN-VD-KORT-008",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "fill_in",
      "question": "Vul in: de ... (verwennen → bijvoeglijk naamwoord) kind was vergeten.",
      "correctAnswer": "verwende",
      "data": {
        "acceptedAnswers": ["verwende"],
        "placeholder": "bijvoeglijk naamwoord...",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Bijvoeglijk naamwoord van VD", "content": "Verwennen is een zwak werkwoord: VD = verwend. Bijvoeglijk naamwoord = VD + e = verwende. 'Verwende' is het juiste bijvoeglijk naamwoord.", "icon": "lightbulb" } }
      ],
      "conceptId": "bn_vd_fill_in_verwende",
      "variantIndex": 8,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Verwennen is een zwak werkwoord. Het voltooid deelwoord is 'verwend'. Bijvoeglijk naamwoord = VD + e = verwende. 'Verwende' is het juiste bijvoeglijk naamwoord.",
        "solutionSteps": [
          "Bepaal het VD: verwennen → verwend",
          "Bijvoeglijk naamwoord = VD + e = verwende",
          "De verwende kind"
        ]
      }
    },
    {
      "id": "SWW-BN-VD-KORT-009",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "fill_in",
      "question": "Vul in: de ... (bakken → bijvoeglijk naamwoord) vis was heerlijk.",
      "correctAnswer": "gebakken",
      "data": {
        "acceptedAnswers": ["gebakken"],
        "placeholder": "bijvoeglijk naamwoord...",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Bijvoeglijk naamwoord van VD", "content": "Bakken is een sterk werkwoord: VD = gebakken. Sterke VD's op -en worden direct als bijvoeglijk naamwoord gebruikt: de gebakken vis.", "icon": "lightbulb" } }
      ],
      "conceptId": "bn_vd_fill_in_gebakken",
      "variantIndex": 9,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Bakken' is een sterk werkwoord. Het voltooid deelwoord is 'gebakken' (ge- + bak + -en). Sterke VD's die eindigen op -en worden direct als bijvoeglijk naamwoord gebruikt, zonder extra -e: de gebakken vis.",
        "solutionSteps": [
          "Bepaal het VD: bakken → gebakken (sterk werkwoord)",
          "Sterk VD op -en → direct als bijvoeglijk naamwoord",
          "De gebakken vis"
        ]
      }
    },
    {
      "id": "SWW-BN-VD-KORT-010",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "error_spotting",
      "question": "Vind de spelfouten bij de bijvoeglijk gebruikte voltooid deelwoorden.",
      "correctAnswer": null,
      "data": {
        "text": "Het gestreeptte shirt lag naast de gewastte broek. De gebroken vaas stond op de verbrandde tafel.",
        "errors": [
          { "word": "gestreeptte", "correction": "gestreepte", "startIndex": 4, "endIndex": 15, "explanation": "'Gestreept' heeft een lange ee-klank. Bij een lange klinker: geen verdubbeling van de t. Gestreept + e = gestreepte." },
          { "word": "gewastte", "correction": "gewaste", "startIndex": 35, "endIndex": 43, "explanation": "'Gewast' heeft een lange a-klank. Bij een lange klinker: geen verdubbeling. Gewast → gewaste. Bovendien valt de t weg: gewas + te = gewaste." },
          { "word": "verbrandde", "correction": "verbrande", "startIndex": 76, "endIndex": 86, "explanation": "'Verbrand' heeft een lange a-klank. Bij een lange klinker: geen verdubbeling van de d. Verbrand + e = verbrande." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Lange klinker = geen verdubbeling", "content": "Bij een lange klinker in het VD verdubbel je de medeklinker NIET. Gestreept + e = gestreepte (niet gestreeptte). Verbrand + e = verbrande (niet verbrandde).", "icon": "lightbulb" } }
      ],
      "conceptId": "bn_vd_error_spotting",
      "variantIndex": 10,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Drie fouten: 1) 'gestreeptte' → gestreepte (lange ee, geen verdubbeling). 2) 'gewastte' → gewaste (lange a, geen verdubbeling). 3) 'verbrandde' → verbrande (lange a, geen verdubbeling). 'Gebroken' is correct — sterk VD op -en.",
        "solutionSteps": [
          "Check elke bijvoeglijke VD: is de klinker lang of kort?",
          "Lange klinker → geen verdubbeling van de medeklinker",
          "gestreeptte → gestreepte, gewastte → gewaste, verbrandde → verbrande"
        ]
      }
    }
  ]
}